var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 6.35156V3.1875H8.10938",
    stroke: "#058F3F",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 3.1875L7.55203 6.90891C7.48673 6.97425 7.4092 7.02607 7.32384 7.06144C7.23853 7.0968 7.14708 7.11501 7.05469 7.11501C6.9623 7.11501 6.87084 7.0968 6.78553 7.06144C6.70017 7.02607 6.62264 6.97425 6.55734 6.90891L5.09109 5.44266C5.0258 5.37731 4.94827 5.32547 4.86293 5.29013C4.77759 5.25478 4.68612 5.23655 4.59375 5.23655C4.50138 5.23655 4.40991 5.25478 4.32457 5.29013C4.23923 5.32547 4.1617 5.37731 4.09641 5.44266L0.726562 8.8125",
    stroke: "#058F3F",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphStats);
export default __webpack_public_path__ + "static/media/graph-stats.86ae5f9682bbda72bc588bfadca48c0f.svg";
export { ForwardRef as ReactComponent };